import { Meta, Story } from '@storybook/react';
import { Default as ConditionStepStory } from '../ConditionStep/ConditionStep.stories';
import { ResultStep, ResultStepProps } from './ResultStep';
export default {
	title: 'Calculators/TravelDeduction/Steps/ResultStep',
	component: ResultStep,
} as Meta;

const Template: Story<ResultStepProps> = (args: ResultStepProps) => <ResultStep {...args} />;

export const Default: Story<ResultStepProps> = Template.bind({});
Default.args = {
	result: {
		description: 'Dit kørselsfradrag er beregnet ud fra de oplysninger, du har indtastet.',
		perDayTitle: 'Pr. dag',
		totalTitle: 'Fradrag i alt',
		helperTexts: {
			daysWithTransport: 'Dage med transport',
			deductionForThePeriod: 'Fradrag for perioden',
			theFirst: 'De første',
		},
	},
	formData: {
		dateStart: 'Jan 1 2023',
		dateEnd: 'Dec 31 2023',
		distance: '1000',
		workingDaysWithTransport: '100',
		year: '2022',
		specialAddress: 'false',
		paymentBridgeUsage: 'false',
		paymentBridges: ['greatBeltBridge', 'oresundBridge'],
		transportType: 'false',
		paymentBridgeBothWays: 'false',
	},
	bridges: ConditionStepStory.args.paymentBridges.options,
	units: {
		kilometers: 'km',
		days: 'dage',
	},
};
